"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeLink = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
/**
 * A version of <Link/> that automatically prepends the currently matched routes path
 *
 * @param props
 * @returns
 */
var RelativeLink = function (props) {
    var url = react_router_dom_1.useRouteMatch().url;
    var relativeTo = url + '/' + props.to.toString();
    relativeTo = relativeTo.replace(/\/+/, '/');
    return react_1.default.createElement(react_router_dom_1.Link, __assign({}, props, { to: relativeTo }));
};
exports.RelativeLink = RelativeLink;
//# sourceMappingURL=RelativeLink.js.map